import { render, staticRenderFns } from "./claimedit_tiaokuan.vue?vue&type=template&id=e913b2c0&scoped=true&"
import script from "./claimedit_tiaokuan.vue?vue&type=script&lang=js&"
export * from "./claimedit_tiaokuan.vue?vue&type=script&lang=js&"
import style0 from "./claimedit_tiaokuan.vue?vue&type=style&index=0&id=e913b2c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e913b2c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e913b2c0')) {
      api.createRecord('e913b2c0', component.options)
    } else {
      api.reload('e913b2c0', component.options)
    }
    module.hot.accept("./claimedit_tiaokuan.vue?vue&type=template&id=e913b2c0&scoped=true&", function () {
      api.rerender('e913b2c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/claimedit_tiaokuan.vue"
export default component.exports